export const orgTypes = [
    { id: 1, label: "Country Unit", value: "1" },
    { id: 2, label: "Subsidiary", value: "2" },
  ];

export const annualRevenueRanges = [
    { id: 1, label: "< 500k", value: "1" },
    { id: 2, label: "500k - 999k", value: "2" },
    { id: 3, label: "1M - 2.49M", value: "3" },
    { id: 4, label: "2.5M - 4.99M", value: "4" },
    { id: 5, label: "5.0M - 9.99M", value: "5" },
    { id: 6, label: "10M - 99.99M", value: "6" },
    { id: 7, label: "100M - 499.99M", value: "7" },
    { id: 8, label: "500M - 999.99M", value: "8" },
    { id: 9, label: "> 1,000M", value: "9" }
  ];